const url = require('url');

/**
 * isParamURL
 * We want to check if the param is an actual param as we
 * dont want people to take advantage and send users to another domain.
 *
 * @param param {string} - A string that comes from a query param
 * @returns {boolean}
 */
const isParamAbsoluteUrl = param => {
  if (!param) {
    return false;
  }
  return !url.parse(param).hostname && param.startsWith('/');
};

module.exports = isParamAbsoluteUrl;



// WEBPACK FOOTER //
// ./src/common/utils/is-param-absolute-url.js